/**
 * @packageDocumentation
 * @module f1/string
 */

import capitalize from './capitalize';

const varParts = /[_\.\s\-\/]/g;

/**
 * flag capitalization on two conditions:
 * 1. the word is longer than 2 characters
 * 2. always capitalize the first word
 *
 * @param w
 * @param index
 */
function sizeWord(w: string, index: number) {
  return w.length < 3 && index > 0 ? w : capitalize(w);
}

export interface Word {
  /**
   * Convert words formatted as variables to English words
   *
   * @public
   * @function f1.word
   * @param s a string of a variable
   * @example
   *
   * ```ts
   * f1.word('__word_is.on-text') === 'Word Is On Text'
   * ```
   */
  (s: string): string;
}

/**
 * @see Word
 */
export default (s: string): string => {
  return `${s}`.toLowerCase().split(varParts).map(sizeWord).join(' ').trim();
};
